<template>
  <div class="p-d-flex p-flex-column">
    <iframe
        ref="angularIframe"
        class="p-d-flex"
        style="height: 90vh"
        frameBorder="0"
        src="/ng/chemicals/bulk-import-global-status"
    ></iframe>
  </div>
</template>

<script>
export default {
  mounted() {
    const frame = this.$refs.angularIframe;

    frame.onload = function () {
      setTimeout(function () {
        frame.style.height = Math.max(500, frame.contentWindow.document.body.scrollHeight + 20) + "px";
      }, 500);
    }
  },
};
</script>